export function IncrementSvg({
   color = '#00AB40',
   size = 12,
}: {
   color?: string
   size?: number
}) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width={size}
         height={size}
         viewBox="0 0 12 12"
         fill="none"
      >
         <g clipPath="url(#clip0_164_1399)">
            <path
               d="M10.3923 3.25595C10.3456 3.18903 10.2878 3.13036 10.2214 3.08361C10.154 3.0364 8.5457 1.94328 6.1587 3.17482C5.82137 3.34853 5.68891 3.76332 5.86262 4.10111C6.03679 4.4389 6.45204 4.57182 6.78891 4.3972C7.48329 4.03878 8.05895 3.95261 8.49712 3.96957L6.21095 6.07745C6.09637 6.18424 5.94466 6.23557 5.79479 6.23282C5.64262 6.2264 5.50145 6.15995 5.39787 6.04536C5.0445 5.65624 4.56187 5.42982 4.03891 5.40782C3.51733 5.3872 3.01408 5.5719 2.62862 5.93124C2.60937 5.94911 2.5915 5.9679 2.575 5.98761L0.962579 7.8732C0.715537 8.16149 0.737079 8.61111 1.0382 8.84257C1.47041 9.1744 1.87145 8.92599 2.00712 8.76649L3.58929 6.9162C3.69975 6.82361 3.83037 6.77778 3.9807 6.7819C4.13333 6.78832 4.27495 6.85478 4.37854 6.96936C4.73145 7.35849 5.21316 7.5849 5.73658 7.6069C6.25862 7.63303 6.76233 7.44328 7.14504 7.08624L9.49583 4.91832C9.52516 5.36978 9.45091 5.97478 9.07554 6.71407C8.90366 7.05278 9.03795 7.46803 9.37712 7.63853C9.82216 7.86174 10.1806 7.57574 10.302 7.33695C11.5198 4.93803 10.4391 3.32424 10.3923 3.25686V3.25595Z"
               fill={color}
            />
         </g>
         <defs>
            <clipPath id="clip0_164_1399">
               <rect
                  width="11"
                  height="11"
                  fill="white"
                  transform="translate(0.335938 0.29834)"
               />
            </clipPath>
         </defs>
      </svg>
   )
}
